import { useEffect } from 'react';
import { Text } from 'foundations-components/components/Text';
import Raven from 'raven-js';
import { warnedTypes, resetWarnedTypes } from './customComponentWarnedTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export { resetWarnedTypes };
const CustomComponentFallbackTransitional = ({
  text,
  warnNamespace,
  warnComponentType
}) => {
  useEffect(() => {
    if (warnNamespace && warnComponentType) {
      const key = `${warnNamespace}/${warnComponentType}`;
      if (!warnedTypes.has(key)) {
        warnedTypes.add(key);
        Raven.captureMessage(`[CustomComponent] unregistered: ${warnNamespace}/${warnComponentType}`, {
          level: 'warning',
          tags: {
            namespace: warnNamespace,
            customComponentType: warnComponentType
          }
        });
      }
    }
  }, [warnNamespace, warnComponentType]);
  return /*#__PURE__*/_jsx(Text, {
    color: "text-core-default",
    children: text
  });
};
export default CustomComponentFallbackTransitional;